var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex full-width py-5"},[_c('div',{staticClass:"align-center d-flex flex-3"},[_c('div',{staticClass:"divider-line"})]),_c('div',{staticClass:"color-gainsboro text-center px-2"},[_vm._v("OR")]),_c('div',{staticClass:"align-center d-flex flex-3"},[_c('div',{staticClass:"divider-line"})])])
}]

export { render, staticRenderFns }